// -------------------------------------------------------------------------
// ハンバーガーメニュー
// -------------------------------------------------------------------------
document.addEventListener("DOMContentLoaded", () => {
    const hamburgerBtns = document.querySelectorAll(".l-hamburger-btn");
    const header = document.querySelector(".l-header");
    const headerMask = document.querySelector(".l-header .c-mask");

    if (hamburgerBtns.length === 0 || !header) {
        return;
    }

    const toggleMenu = () => {
        document.documentElement.classList.toggle("is-noscroll");
        document.documentElement.classList.toggle("is-hamburger-active");
    };

    const removeHamburgerActiveClass = () => {
        document.documentElement.classList.remove("is-hamburger-active");
        document.documentElement.classList.remove("is-noscroll");
    };

    // ハンバーガーボタンのクリックイベント
    hamburgerBtns.forEach((btn) => {
        btn.addEventListener("click", toggleMenu);
    });

    // メニュー内リンクのクリック時の処理
    header.addEventListener("click", (event) => {
        const target = event.target;

        // 特定の条件でメニューを閉じない
        if (
            target.closest(".l-hamburger-accordion__toggle") || // アコーディオンのトグル
            target.closest(".l-header-subnavigation-toggle")   // サブナビゲーションのトグル
        ) {
            // メニューを閉じないので早期リターン
            return;
        }

        // マスクエリアや他のリンクの場合は閉じる
        if (
            target.closest(".l-hamburger a") ||
            target === headerMask
        ) {
            removeHamburgerActiveClass();
        }
    });

    // ウィンドウリサイズ時にメニューを閉じる
    window.addEventListener("resize", () => {
        if (
            document.documentElement.classList.contains("is-hamburger-active") &&
            window.innerWidth >= 769
        ) {
            removeHamburgerActiveClass();
        }
    });
});



// アコーディオン
document.addEventListener("DOMContentLoaded", () => {
    const navLinks = document.querySelectorAll(
        ".l-hamburger-accordion__toggle"
    )

    const toggleActiveClass = (event) => {
        if (window.innerWidth < 768) {
            event.preventDefault()
            const parentLi = event.currentTarget.closest(".l-hamburger-accordion")
            parentLi.classList.toggle("is-active")
        }
    }

    navLinks.forEach((link) => {
        link.addEventListener("click", toggleActiveClass)
    })

    window.addEventListener("resize", () => {
        if (window.innerWidth >= 768) {
            document
            .querySelectorAll(".l-hamburger-accordion.is-active")
            .forEach((item) => {
                item.classList.remove("is-active")
            })
        }
    })
})

// サブナビゲーション
// Note: Height calculation logic removed to support full-screen overlay design.
document.addEventListener("DOMContentLoaded", () => {
    const toggleButtons = document.querySelectorAll(".l-header-subnavigation-toggle");
    const backButtons = document.querySelectorAll(".l-header-subnavigation__btn");
    // const hamburger = document.querySelector(".l-hamburger");

    const matchMedia = window.matchMedia('(max-width: 768px)');

    // トグルボタンのクリック処理
    const handleToggleClick = (event) => {
        event.preventDefault();
        const subNavigation = event.currentTarget.parentElement.querySelector(".l-header-subnavigation");
        if (subNavigation) {
            subNavigation.classList.add("is-active");
        }
    };

    // 戻るボタンのクリック処理
    const handleBackClick = (event) => {
        const subNavigation = event.currentTarget.closest(".l-header-subnavigation");
        if (subNavigation) {
            subNavigation.classList.remove("is-active");
        }
    };

    // イベントリスナーの登録
    const addListeners = () => {
        toggleButtons.forEach((button) => button.addEventListener("click", handleToggleClick));
        backButtons.forEach((button) => button.addEventListener("click", handleBackClick));
    };

    // イベントリスナーの解除
    const removeListeners = () => {
        toggleButtons.forEach((button) => button.removeEventListener("click", handleToggleClick));
        backButtons.forEach((button) => button.removeEventListener("click", handleBackClick));
    };

    // 初期化
    const initSubNavigation = () => {
        if (matchMedia.matches) {
            addListeners();
        } else {
            removeListeners();
            // hamburger.style.height = ""; // Reset handled by CSS
        }
    };

    // 初期化実行
    initSubNavigation();

    // ウィンドウサイズ変更時の処理
    matchMedia.addEventListener("change", () => {
        initSubNavigation();
    });
});
